import React from 'react';
import { ItemPill, RemoveItem } from '../../../styles';
import CloseIcon from '../../../assets/icons/Close';

const Index = ({ item, handleUpdate }) => {
  return (
    <ItemPill key={item?.code}>
      <div>{item?.name}</div>
      <RemoveItem onClick={() => handleUpdate(item)}>
        <CloseIcon />
      </RemoveItem>
    </ItemPill>
  );
};

export default Index;
